// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d987f3ec","863":"4c910028"}[chunkId] + ".chunk.js";
};